





























import { Component, Vue } from 'vue-property-decorator';
import { ClickEventArgs } from '@syncfusion/ej2-vue-navigations';
import CFMGridPage from '@/scripts/CFMGridPage'

import * as swal from '@/helpers/swal'
import * as blockui from '@/helpers/block-ui'

import { CFMDTOSparePart } from '@/scripts/services/ClientApiAuto'
import SparePartTypeDialog from './SparePartTypeDialog.vue'

@Component<SparePart>({
    components: {
        'spare-part-type-dialog': SparePartTypeDialog,
    }
})
export default class SparePart extends CFMGridPage<CFMDTOSparePart> {
    entityType = "SparePartSettings";
    sorts:{field:string,direction:string}[] = [{ field:"Id", direction:"Descending" }];
    isDuplicate = false;
    async mounted(){
        this.dataStateChange(this.state);
    }
    refreshGrid(){
        this.dataStateChange(this.state);
    }
    recordDoubleClick(args:any){
        this.edit(args.rowData.Id);
    }
    async delete(data: CFMDTOSparePart){
        const e = await swal.check(this, data.Name);
        if (e.value) {
            blockui.pageBlock(this);
            const response = await this.apiClient.sparePart.sparePartDelete({id: data.Id});
            if (response.data.IsSuccess) {
                toastr.success(this.translate('delete_successfully'));
                this.refreshGrid();
            } else {
                const errorMessage = response.data.Message ? response.data.Message : "Error";
                toastr.error(errorMessage);
            }
            blockui.unBlockPage();
        }
    }
    async edit(id: number){
        this.selectedId = id;
        this.isDialogActive = true;
        await this.$nextTick();
        (<SparePartTypeDialog>this.$refs.sparePartTypeDialog).showDialog();
    }
    async add(){
        this.selectedId = null;
        this.isDialogActive = true;
        await this.$nextTick();
        (<SparePartTypeDialog>this.$refs.sparePartTypeDialog).showDialog();
    }
    async toolbarClick(args: ClickEventArgs){
        var selectedRecords = (<any>this.$refs.grid).getSelectedRecords();
        if (args.item.id === 'Edit') {
            if(selectedRecords.length > 0){
                this.edit(selectedRecords[0].Id);
            }
        }
        else if(args.item.id === 'Add'){
               this.add();
        }
        else if(args.item.id === 'Delete'){
            if(selectedRecords.length > 0){
                this.delete(selectedRecords[0]);
            }
        }
      this.toolbarClickBase(args);
    }
    duplicateTemplate() {
      const self = this;
      const methods = {
          async duplicate(data: any) {
            self.selectedId = data.Id;
            self.isDuplicate = true;
            self.isDialogActive = true;
            await self.$nextTick();
            (<SparePartTypeDialog>self.$refs.sparePartTypeDialog).showDialog();
          }
      };
      return {
          template: Vue.component("columnTemplate", {
              template: `<div><button @click="duplicate(data)" class="e-lib e-btn e-control e-icon-btn" v-lang.copy><span class="e-btn-icon e-icons e-copy"></span></button></div>`,
              methods: methods,
          }),
      };
  }
}
